// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__26FPM","text":"SelectPayment_text__2yVq4","title":"SelectPayment_title__I-x4G","btn":"SelectPayment_btn__1dQBA"};